import Address from './Address';
import SavedPayments from './SavedPayments';
// import Wallet from './Wallet';
import Referral from './Referral';
import FAQs from './FAQs';
import TnC from './TnC';
import PrivacyPolicy from './PrivacyPolicy';
import HBMoney from './Wallet/HBMoney';
import LandingPage from './HBPoint/LandingPage';
import { CC_WHATSAPP_LINK } from 'hb-redux-store/constants/whatsappHelp';

export const ACCOUNTS_PREFIX = 'my';
const HELP_PREFIX = 'help';

export const ACCOUNTS_MENU = [
  {
    title: 'My Account',
    key: 'account',
    expanded: true,
    isPrivate: true,
    helpText: 'Address, Payments, Wallet & Referrals',
    subMenu: [
      {
        title: 'My Address',
        key: 'addresses',
        url: `/${ACCOUNTS_PREFIX}/addresses`,
        icon: 'icon-payment-home',
        isPrivate: true,
        component: Address,
      },
      {
        title: 'Payment',
        key: 'payments',
        url: `/${ACCOUNTS_PREFIX}/payments`,
        icon: 'icon-payment-rupee',
        isPrivate: true,
        component: SavedPayments,
      },
      // {
      //   title: 'Halal Box Wallet',
      //   key: 'hb-wallet',
      //   url: `/${ACCOUNTS_PREFIX}/halalbox-wallet`,
      //   icon: 'icon-payment-wallet',
      //   isPrivate: true,
      //   component: Wallet,
      // },
      {
        title: '<span>VXL <span class="bold">Points</span></span>',
        key: 'vxl-point',
        url: `/${ACCOUNTS_PREFIX}/vxl-point`,
        icon: 'icon-hb-point-icon',
        isPrivate: true,
        component: LandingPage,
        isNew: true,
      },
      {
        title: '<span>VXL <span class="bold">Money</span></span>',
        key: 'vxl-money',
        url: `/${ACCOUNTS_PREFIX}/vxl-money`,
        icon: 'icon-payment-wallet',
        isPrivate: true,
        component: HBMoney,
        isNew: true,
      },
      // {
      //   title: 'Refer and Earn',
      //   key: 'referral',
      //   url: `/${ACCOUNTS_PREFIX}/referrals`,
      //   icon: 'icon-payment-gift',
      //   isPrivate: true,
      //   component: Referral,
      // },
      {
        title: 'Logout',
        key: 'logout',
        url: `/`,
        icon: 'icon-accounts-logout',
        isPrivate: true,
        component: () => false,
      },
    ],
  },
  {
    title: 'Help',
    key: 'help',
    expanded: true,
    isPrivate: false,
    helpText: 'FAQs, Terms & Conditions & Policy',
    subMenu: [
      {
        title: 'Contact us on Whatsapp',
        key: 'contact-us',
        url: CC_WHATSAPP_LINK,
        icon: 'icon-whatsapp-flat',
        isPrivate: false,
        isExternalLink: true,
        component: FAQs,
      },
      {
        title: 'FAQ',
        key: 'faq',
        url: `/${HELP_PREFIX}/faqs`,
        icon: 'icon-payment-faqs',
        isPrivate: false,
        component: FAQs,
      },
      {
        title: 'Terms & Conditions',
        key: 'tnc',
        url: `/${HELP_PREFIX}/tnc`,
        icon: 'icon-payment-tnc',
        isPrivate: false,
        component: TnC,
      },
      {
        title: 'Policy',
        key: 'privacyPolicy',
        url: `/${HELP_PREFIX}/privacy-policy`,
        icon: 'icon-payment-policy',
        isPrivate: false,
        component: PrivacyPolicy,
      },
    ],
  },
];

export const FOOTER_MENU = [
  {
    title: 'FAQ',
    key: 'faq',
    url: `/${HELP_PREFIX}/faqs`,
    icon: 'icon-payment-faqs',
    isPrivate: false,
    component: FAQs,
  },
  {
    title: 'Terms & Conditions',
    key: 'tnc',
    url: `/${HELP_PREFIX}/tnc`,
    icon: 'icon-payment-tnc',
    isPrivate: false,
    component: TnC,
  },
  {
    title: 'Policy',
    key: 'privacyPolicy',
    url: `/${HELP_PREFIX}/privacy-policy`,
    icon: 'icon-payment-policy',
    isPrivate: false,
    component: PrivacyPolicy,
  },
];
